import { restClient } from '@/Core'

interface PresenceSubscription {
    channel: string
    token: string
}

/**
 * Назва presence-каналу орендаря і підписний токен до нього. Викликається
 * при підключенні і повторно з getToken centrifuge-js, коли токен протух —
 * тому завжди повз кеш.
 */
export const GetPresenceTokenTask = async (): Promise<PresenceSubscription> => {
    const response = (await restClient.get(
        '/services/chat/presence/token',
        {},
        { forceRefresh: true }
    )) as Partial<PresenceSubscription> | null

    if (!response?.channel || !response?.token) {
        throw new Error('Presence subscription token unavailable')
    }

    return { channel: response.channel, token: response.token }
}
